import d from "debug";
import { createApp, h, type Component } from "vue";
import { appPlugins } from "@kce2/app";

const debug = d("open-dialog");
export async function openDialog(DialogComponent: Component, props: any, children?: any) {
  const { onClose, onOk, onAfterClose, ok, ...restProps } = props;
  return new Promise<boolean>((resolve, reject) => {
    function renderDialogVM() {
      return h(
        DialogComponent,
        {
          // make sure the dialog is shown by default if possible
          visible: true,
          show: true,
          value: true,
          modelValue: true,
          open: true,

          // !!! be care for with $attrs overrides
          ...restProps,
          onClose: internalOnClose,
          onOk: internalOnOk,
          onAfterClose: internalOnAfterClose,
          ok: internalOk,
        },
        children,
      );
    }
    debug("restProps", restProps);
    const container = document.createElement("div");
    document.body.appendChild(container);
    const app = createApp({
      render: renderDialogVM,
    });
    debug("use vue plugins", appPlugins);
    for (const plg of appPlugins) {
      if (Array.isArray(plg)) {
        app.use(plg[0], plg[1]);
      } else {
        app.use(plg);
      }
    }
    app.mount(container);

    function unmount() {
      app.unmount();
      document.body.removeChild(container);
    }

    function internalOnOk() {
      debug("internalOnOk");
      onOk?.();
      resolve(true);
    }
    async function internalOk() {
      debug("internalOk");
      if (ok) {
        const res = await ok();
        if (res) {
          resolve(true);
          unmount();
        }
      } else {
        resolve(true);
        unmount();
      }
    }
    function internalOnClose() {
      onClose?.();
      reject(false);
    }
    function internalOnAfterClose() {
      onAfterClose?.();
      unmount();
    }
  });
}
